// extracted by mini-css-extract-plugin
module.exports = {"logo":"login_logo__xo_Vn","formDescription":"login_formDescription__1-y3C","login":"login_login__nswcu","entranceOptions":"login_entranceOptions__1CKDL"};